export default __webpack_public_path__ + "static/media/The Spooky-Tempered Clavier.dc335edf.png";